import React from 'react';
import { Navigate, Outlet } from 'react-router';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { selectAuthData } from './redux/selectors/auth';

import { ROLES } from './Constants';
import { selectUserType } from './redux/selectors/userType.js';

export default function ProtectedRoute({ type }) {
  const { isLoading, user: { email: userEmail = '' } = {} } = useSelector(selectAuthData);
  const { isAdmin, isSuperAdmin } = useSelector(selectUserType);

  const redirectPath = '/login';
  let isAuthenticated = false;


  if(isLoading){
    return null
  }
  // Wait until user type is initialized
  const isUserTypeLoading = isAdmin === null || isSuperAdmin === null;
  
  if (isLoading || isUserTypeLoading) {
    return null;
  }

  const roleArray = Array.isArray(type) ? type : [type];

 

  for (const role of roleArray) {
    switch (role) {
      case ROLES.USER:
        isAuthenticated = !!userEmail;
        break;
      case ROLES.ADMIN:
        isAuthenticated = (isAdmin || isSuperAdmin) && !!userEmail;
        break;
      case ROLES.SUPER_ADMIN:
        isAuthenticated = isSuperAdmin && !!userEmail;
        break;
      default:
        isAuthenticated = false;
    }

    if (isAuthenticated) break;
  }


  return isAuthenticated ? <Outlet /> : <Navigate to={redirectPath} replace />;
}

ProtectedRoute.propTypes = {
  type: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired
};
